const round = (number) => Math.round(number * 100) / 100;

const monitorReducerEnhancer = (storeAPI) => (next) => (action) => {
    const start = performance.now();
    console.log('dispatching', action);
    const result = next(action);
    console.log('next state', storeAPI.getState());
    const end = performance.now();
    const diff = round(end - start);
    console.log(`reducer process time: ${diff} microseconds`);
    return result;
};

export default monitorReducerEnhancer;
